import { expVal } from '@atlassian/jira-feature-experiments';
import { getWillShowNav4 } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/utils/get-will-show-nav4/index.tsx';
import { useIsActiveRoute } from '@atlassian/react-resource-router';
import type { RouteName } from '@atlassian/jira-route-name-types/src/RouteName.tsx';
import { useIsAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-admin/index.tsx';
import {
	useIsSimplifiedProject,
	useProjectContext,
} from '@atlassian/jira-providers-project-context/src/index.tsx';

/**
 * We want to show the extended share dialog when the following conditions are met:
 * - All nav4 views OR board/backlog/timeline/issue views in nav3 for TMP
 * - User is a Jira admin or project admin
 * - Extended share dialog experiment is enabled
 *
 * @returns {boolean} Whether the extended share dialog is enabled
 */
export const useIsExtendedShareDialogEnabled = (): boolean => {
	const isAdmin = useIsAdmin();
	const { data: projectContextData } = useProjectContext();
	const isProjectAdmin = !!projectContextData?.isProjectAdmin;
	const isTMP = useIsSimplifiedProject();

	const projectType = projectContextData?.projectType;
	const isBusinessOrSoftwareProject = projectType === 'business' || projectType === 'software';

	const shouldShowInNav3View = useIsActiveRoute(
		new Set<RouteName>(['software-timeline', 'software-boards', 'software-backlog', 'issue']),
	);

	return (
		(getWillShowNav4() || shouldShowInNav3View) &&
		isBusinessOrSoftwareProject &&
		isTMP &&
		(isAdmin || isProjectAdmin) &&
		expVal('tmp_secure_project_access_share_dialog', 'isEnabled', false)
	);
};
